import "../../arDominionB5Plugin/js/main";

// SkipTo accessibility configuration
window.SkipToConfig = {
  landmarks: 'main search navigation',
  headings: 'h1 h2 h3',
  displayOption: 'popup',
  // Custom colors matching official University of Waterloo brand colors
  buttonTextColor: '#000000',           // Black text
  buttonTextDarkColor: '#FFFFFF',       // White text for dark mode
  buttonBackgroundColor: '#FFD54F',     // University of Waterloo gold
  buttonBackgroundDarkColor: '#000000', // Black for dark mode
  focusBorderColor: '#666666',          // Medium gray focus border
  focusBorderDarkColor: '#FFFFFF',      // White focus border for dark mode
  menuTextColor: '#000000',             // Black menu text
  menuTextDarkColor: '#FFFFFF',         // White menu text for dark mode
  menuBackgroundColor: '#FFFFFF',       // White menu background
  menuBackgroundDarkColor: '#000000',   // Black menu background for dark mode
  menuitemFocusTextColor: '#000000',    // Black text when focused
  menuitemFocusTextDarkColor: '#000000', // Black text when focused in dark mode
  menuitemFocusBackgroundColor: '#FFD54F', // Gold background when focused
  menuitemFocusBackgroundDarkColor: '#FFFFFF' // White background when focused in dark mode
};

import "./skipto.min";

/*

Extra/custom JS:

jQuery, $ and bootstrap are exposed globally. Also Drupal and Qubit,
but avoid its usage. Allows IIFEs, CommonJS, ES6 Modules and it could
allow Typescript if it's implemented in the Webpack build process.

*/
